export const LINE_REDIRECT_URL = `https://liff.line.me/${
  process.env.LINE_LIFF_ID ?? '1656914823-p4LDgAog'
}`;

export function getLineRedirectURL(payload: object) {
  const payloadStr = payload ? JSON.stringify(payload) : '';

  if (payloadStr) {
    return `${LINE_REDIRECT_URL}?payload=${encodeURIComponent(payloadStr)}`;
  }

  return `${LINE_REDIRECT_URL}`;
}
